export function getTagFilterParamsKey(tag) {
  switch (tag.schema) {
    case 'categories':
      return 'category_ids';
    case 'subcategories':
      return 'subcategory_ids';
    case 'universities':
      return 'university_ids';
    case 'cities':
      return 'city_ids';
    case 'provinces':
      return 'province_ids';
    default:
      throw new Error('Unrecognized tag schema');
  }
}

export function parseHiddenTags(hiddenTags) {
  const payload = {};
  hiddenTags.forEach(tag => {
    const key = getTagFilterParamsKey(tag);
    if (payload[key]) {
      payload[key].push(tag.id);
    } else {
      payload[key] = [tag.id];
    }
  });
  return payload;
}

export function parseFilters(filters = {}) {
  const { isFavorite, isHidden, tags } = filters;
  let payload = {};
  // Translate recommendation params
  if (isFavorite !== undefined) {
    payload.is_favorite = isFavorite ? 'True' : 'False';
  }

  if (isHidden !== undefined) {
    payload.is_hidden = isHidden ? 'True' : 'False';
  }

  // Translate tags
  if (tags !== undefined) {
    tags.forEach(tag => {
      let key = getTagFilterParamsKey(tag);
      if (!payload[key]) {
        payload[key] = [tag.id];
      } else {
        payload[key].push(tag.id);
      }
    });
  }

  return payload;
}



// WEBPACK FOOTER //
// ./src/services/recommendationParamsService.js